import { ApproverType } from '@amzn/snow-data-service-typescript-client';
import { WorkflowIntention } from '@amzn/snow-nxt-workflow-service-typescript-client';
import { ApprovalMetadata } from 'src/stores/workflowCreateDataStore/workflowCreateDataStore.interface';

//TOD0: To be replaced with the List Domain API
export const DOMAIN_OPTIONS = [
	{
		label: 'SNOW',
		value: 'SNOW',
	},
];

export const APPROVAL_METADATA: ApprovalMetadata[] = [
	{
		approverAlias: '',
		approverType: { value: ApproverType.POSIX },
		numberOfApprovers: '1',
		level: '5',
	},
];

export const WORKFLOW_INTENTION_OPTIONS = [
	{ label: WorkflowIntention.CREATE, value: WorkflowIntention.CREATE },
	{ label: WorkflowIntention.UPDATE, value: WorkflowIntention.UPDATE },
	{ label: WorkflowIntention.DELETE, value: WorkflowIntention.DELETE },
];

export const DEFAULT_WORKFLOW_INTENTION = WorkflowIntention.CREATE;
